import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-emerald-50 to-white" data-id="element-37">
      <div className="max-w-7xl mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-4xl mx-auto" data-id="element-39">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-40">
            Premium Qualified Calls.{' '}
            <span className="text-emerald-600" data-id="element-41">Delivered at Scale.</span>
          </h1>
          <p className="text-xl md:text-2xl text-slate-600 mb-10 leading-relaxed" data-id="element-42">
            Your Trusted Partner for High-Intent Consumer Calls
          </p>
          <p className="text-lg text-slate-700 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-43">
            At Growthlyfe, we connect qualified leads with trusted insurance
            providers across multiple verticals. We generate our own
            high-quality leads in-house and broker premium traffic to get you
            the best results.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-44">
            <button onClick={scrollToContact} className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:shadow-lg hover:scale-105" data-id="element-45">
              For Advertisers
            </button>
            <button onClick={scrollToContact} className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:shadow-lg hover:scale-105" data-id="element-46">
              For Publishers
            </button>
          </div>
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="mt-12 text-sm text-slate-500 font-medium" data-id="element-47">
            Trusted by Leading Brands Across Insurance, Finance, and Home
            Services
          </motion.p>
        </motion.div>
      </div>
    </section>;
}